// src/MessageBubble.tsx
import React from "react";

interface Props {
  sender: string;
  text: string;
  timestamp?: string;
  isOwn: boolean;
  colors: any;
}

const MessageBubble: React.FC<Props> = ({ sender, text, timestamp, isOwn, colors }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: isOwn ? "flex-end" : "flex-start",
        marginBottom: 12,
        animation: "fadeIn 0.3s ease-in-out",
      }}
    >
      {!isOwn && (
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#6366f1",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            marginRight: 8,
          }}
        >
          {sender.charAt(0).toUpperCase()}
        </div>
      )}
      <div
        style={{
          padding: "10px 14px",
          borderRadius: 12,
          backgroundColor: isOwn ? colors.msgOwn : colors.msgOther,
          maxWidth: "70%",
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: 14 }}>{sender}</div>
        <div style={{ fontSize: 15 }}>{text}</div>
        {timestamp && (
          <div style={{ fontSize: 11, opacity: 0.6, marginTop: 4 }}>
            {new Date(timestamp).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
